'use strict'

import State from 'ampersand-state'
import { map, flatten, find, defaultsDeep, extend, result, pick, filter, groupBy } from 'lodash/fp'

const DeviceModel = State.extend({
  resolutions: {
    qvga: {width: {ideal: 320}, height: {ideal: 240}},
    vga: {width: {ideal: 640}, height: {ideal: 480}},
    hd: {width: {ideal: 1280}, height: {ideal: 720}}
  },
  props: {
    id: 'string',
    kind: 'string',
    deviceId: 'string',
    groupId: 'string',
    resolution: ['string', true, 'hd'],
    label: 'string',
    logger: 'object',
    track: 'object',
    webrtc: 'state'
  },
  derived: {
    displayName: {
      deps: ['label', 'deviceId', 'type'],
      fn () {
        if (this.deviceId === 'default') {
          return `Default ${this.type}`
        }
        return this.label ? this.label.split(/\s\(.*\:.*\)/)[0] : 'Some device'
      }
    },
    type: {
      deps: ['kind'],
      fn () {
        if (this.kind === 'audioinput') {
          return 'microphone'
        } else if (this.kind === 'videoinput') {
          return 'webcam'
        } else if (this.kind === 'audiooutput') {
          return 'speakers'
        }
      }
    }
  },
  initialize () {
    
  },
  async getTrack () {
    if (this.track) this.track.stop()
    if (this.kind === 'audioinput') {
      this.track = await this._getTrackMicrophone()
    } else if (this.kind === 'videoinput') {
      this.track = await this._getTrackWebcam()
    }
    return this.track
  },
  async _getTrackWebcam () {
    try {
      const stream = await this.webrtc.getUserMedia({
        video: extend({
          deviceId: {exact: this.deviceId}
        })(this.resolutions[this.resolution])
      })
      return stream.getVideoTracks()[0]
    } catch (err) {
      this.logger.warn('Failed to get track for device')
      throw err
    }
  },
  async _getTrackMicrophone () {
    try {
      const stream = await this.webrtc.getUserMedia({
        audio: {
          deviceId: this.deviceId
        }
      })
      return stream.getAudioTracks()[0]
    } catch (err) {
      this.logger.warn('Failed to get track for device')
      throw err
    }
  }
})

export default DeviceModel



// WEBPACK FOOTER //
// ./client/webrtc/greenroom-device-model.js